<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <b-form @submit="onSubmit1" @reset="onReset1" v-if="show">
          <b-form-group
            label="1. SE PRESENTA DE FORMA CORRECTA"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_1"
                  :aria-describedby="ariaDescribedby"
                  name="question_1"
                  value="1"
                  required
                  >BAJO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_1"
                  :aria-describedby="ariaDescribedby"
                  name="question_1"
                  value="3"
                  required
                  >REGULAR</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 3</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_1"
                  :aria-describedby="ariaDescribedby"
                  name="question_1"
                  value="5"
                  required
                  >BUENO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 5</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_1"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>

          <b-form-group
            label="2. MANEJO DEL SCRIPT"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_2"
                  :aria-describedby="ariaDescribedby"
                  name="question_2"
                  value="1"
                  required
                  >BAJO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_2"
                  :aria-describedby="ariaDescribedby"
                  name="question_2"
                  value="3"
                  required
                  >REGULAR</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 3</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_2"
                  :aria-describedby="ariaDescribedby"
                  name="question_2"
                  value="5"
                  required
                  >BUENO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 5</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_2"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>

          <b-form-group
            label="3. TIPIFICACIÓN CORRECTA"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_3"
                  :aria-describedby="ariaDescribedby"
                  name="question_3"
                  value="1"
                  required
                  >BAJO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_3"
                  :aria-describedby="ariaDescribedby"
                  name="question_3"
                  value="3"
                  required
                  >REGULAR</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 3</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_3"
                  :aria-describedby="ariaDescribedby"
                  name="question_3"
                  value="5"
                  required
                  >BUENO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 5</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_3"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>

          <b-form-group
            label="4. UTILIZA ARGUMENTO DE VENTA"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_4"
                  :aria-describedby="ariaDescribedby"
                  name="question_4"
                  value="1"
                  required
                  >BAJO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_4"
                  :aria-describedby="ariaDescribedby"
                  name="question_4"
                  value="3"
                  required
                  >REGULAR</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 3</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_4"
                  :aria-describedby="ariaDescribedby"
                  name="question_4"
                  value="5"
                  required
                  >BUENO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 5</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_4"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>

          <b-form-group
            label="5. BUSCA GENERAR SEGUIMIENTO PARA LA CONVERSIÓN"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_5"
                  :aria-describedby="ariaDescribedby"
                  name="question_5"
                  value="1"
                  required
                  >BAJO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_5"
                  :aria-describedby="ariaDescribedby"
                  name="question_5"
                  value="3"
                  required
                  >REGULAR</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 3</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_5"
                  :aria-describedby="ariaDescribedby"
                  name="question_5"
                  value="5"
                  required
                  >BUENO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 5</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_5"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>

          <b-form-group
            label="6. DOMINIO DE  LA INFORMACIÓN - MANEJO DE LA LLAMADA"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_6"
                  :aria-describedby="ariaDescribedby"
                  name="question_6"
                  value="1"
                  required
                  >BAJO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_6"
                  :aria-describedby="ariaDescribedby"
                  name="question_6"
                  value="3"
                  required
                  >REGULAR</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 3</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_6"
                  :aria-describedby="ariaDescribedby"
                  name="question_6"
                  value="5"
                  required
                  >BUENO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 5</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_6"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>

          <b-form-group
            label="7. UTILIZA LENGUAJE APROPIADO"
            v-slot="{ ariaDescribedby }"
          >
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_7"
                  :aria-describedby="ariaDescribedby"
                  name="question_7"
                  value="1"
                  required
                  >BAJO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 1</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_7"
                  :aria-describedby="ariaDescribedby"
                  name="question_7"
                  value="3"
                  required
                  >REGULAR</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 3</div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <b-form-radio
                  v-model="form.selected_7"
                  :aria-describedby="ariaDescribedby"
                  name="question_7"
                  value="5"
                  required
                  >BUENO</b-form-radio
                >
              </div>
              <div class="col-sm-6 text-right puntos">Puntos: 5</div>
            </div>

            <b-form-textarea
              class="textarea_margin"
              id="textarea"
              v-model="form.text_7"
              placeholder="Agregar comentarios…"
              rows="1"
              max-rows="6"
            >
            </b-form-textarea>
          </b-form-group>

          <b-row class="text-center" align-v="center">
            <b-col>
              <b-button type="submit" class="Rectangle-Copy" variant="primary"
                >Guardar</b-button
              >
              <b-button type="reset" class="Rectangle-Copy-19" variant="danger"
                >Limpiar</b-button
              >
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    evaluador: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      show: true,
      formSave: "Calidad Ventas",
      form: {
        selected_1: null,
        selected_2: null,
        selected_3: null,
        selected_4: null,
        selected_5: null,
        selected_6: null,
        selected_7: null,
        text_1: null,
        text_2: null,
        text_3: null,
        text_4: null,
        text_5: null,
        text_6: null,
        text_7: null,
      },
    };
  },
  methods: {
    onSubmit1(event) {
      event.preventDefault();
      console.log(this.formSave);
      console.log(this.evaluador);
      var evaluacion = {
        interaction_id: this.$route.params.recording_id,
        form: this.formSave,
        evaluator: this.evaluador,
        evaluations: this.form,
        questions: [
          {
            value: 1,
            text: "SE PRESENTA DE FORMA CORRECTA",
          },
          {
            value: 2,
            text: "MANEJO DEL SCRIPT",
          },
          {
            value: 3,
            text: "TIPIFICACIÓN CORRECTA",
          },
          {
            value: 4,
            text: "UTILIZA ARGUMENTO DE VENTA",
          },
          {
            value: 5,
            text: "BUSCA GENERAR SEGUIMIENTO PARA LA CONVERSIÓN",
          },
          {
            value: 6,
            text: "DOMINIO DE LA INFORMACIÓN - MANEJO DE LA LLAMADA",
          },
          {
            value: 7,
            text: "UTILIZA LENGUAJE APROPIADO",
          },
        ],
      };
      console.log(evaluacion);
      this.axios
        .post("/api/createevaluation", evaluacion)
        .then((result) => {
          console.log(result);

          const itemFlush = {
            title: "Success",
            message: "Evaluacion Creada",
            time: 3000,
          };
          this.sendFlushData(itemFlush);
          this.form.selected_1 = null;
          this.form.selected_2 = null;
          this.form.selected_3 = null;
          this.form.selected_4 = null;
          this.form.selected_5 = null;
          this.form.selected_6 = null;
          this.form.selected_7 = null;

          this.form.text_1 = null;
          this.form.text_2 = null;
          this.form.text_3 = null;
          this.form.text_4 = null;
          this.form.text_5 = null;
          this.form.text_6 = null;
          this.form.text_7 = null;

          this.show = false;
          this.$nextTick(() => {
            this.show = true;
          });
        })
        .catch((error) => {
          console.log(error.response.status);
          const itemFlush = {
            title: "Error",
            message: "Intente Nuevamente",
            time: 3000,
          };
          this.sendFlushData(itemFlush);
          if (error.response.status === 403) {
            this.$store.dispatch("auth/logout");
            this.$router.push("/login");
          }
        });
    },
    onReset1(event) {
      event.preventDefault();
      // Reset our form values
      this.form.selected_1 = null;
      this.form.selected_2 = null;
      this.form.selected_3 = null;
      this.form.selected_4 = null;
      this.form.selected_5 = null;
      this.form.selected_6 = null;
      this.form.selected_7 = null;

      this.form.text_1 = null;
      this.form.text_2 = null;
      this.form.text_3 = null;
      this.form.text_4 = null;
      this.form.text_5 = null;
      this.form.text_6 = null;
      this.form.text_7 = null;

      const itemFlush = {
        title: "Info",
        message: "Formulario limpiado correctamente",
        time: 3000,
      };
      this.sendFlushData(itemFlush);
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    sendFlushData(item) {
      this.$emit("getFlushData", item);
    },
  },
};
</script>

<style>
</style>